import { useCallback } from "react";

export const useVideoURL = () => {
    const YOUTUBE_EMBED_URL = "https://www.youtube.com/embed/";

    const getYoutubeEmbededURL = useCallback((url: string): string => {
        try {
            const parsedUrl = new URL(url);

            const isYoutubeCom = parsedUrl.hostname.includes('youtube.com');
            const isYoutubeBe = parsedUrl.hostname === 'youtu.be';
            const isEmbdedURL = parsedUrl.pathname.startsWith('/embed/');

            if (isYoutubeCom && isEmbdedURL) {
                return url;
            }

            if (isYoutubeBe) {
                const videoId = parsedUrl.pathname.slice(1);
                return YOUTUBE_EMBED_URL + videoId;
            }

            if (isYoutubeCom && parsedUrl.pathname === '/watch') {
                const videoId = parsedUrl.searchParams.get('v');
                return videoId ? YOUTUBE_EMBED_URL + videoId : url;
            }
            return url;
        } catch (err) {
            console.error(err);
            return url;
        }
    }, []);

    return {
        getYoutubeEmbededURL
    }
}